import { createTheme } from '@mantine/core'

export const theme = createTheme({
  /** Broadcast environment theme configuration */
  primaryColor: 'blue',
  
  /** Color scheme optimized for broadcast environments */
  colors: {
    // Custom colors for routing states - optimized for broadcast environments
    connected: [
      '#e8f5e8', // Very light green background
      '#d4edda', // Light green for subtle backgrounds
      '#c3e6cb', // Soft green
      '#a3d977', // Medium green
      '#82c341', // Bright green
      '#28a745', // Primary connected state - strong green
      '#218838', // Darker green for borders
      '#1e7e34', // Deep green
      '#155724', // Very dark green
      '#0d4017'  // Darkest green
    ],
    disconnected: [
      '#f8f9fa', // Very light gray
      '#e9ecef', // Light gray background
      '#dee2e6', // Soft gray
      '#ced4da', // Medium gray
      '#adb5bd', // Standard gray
      '#6c757d', // Primary disconnected state
      '#495057', // Dark gray
      '#343a40', // Darker gray
      '#212529', // Very dark gray
      '#000000'  // Black
    ],
    // Custom colors for error states - high contrast red
    error: [
      '#f8d7da', // Very light red background
      '#f5c6cb', // Light red
      '#f1b0b7', // Soft red
      '#ec7063', // Medium red
      '#e74c3c', // Bright red
      '#dc3545', // Primary error state - strong red
      '#c82333', // Darker red for borders
      '#bd2130', // Deep red
      '#a71e2a', // Very dark red
      '#8b1a1a'  // Darkest red
    ],
    // Custom colors for loading/transitional states - amber/yellow
    loading: [
      '#fff3cd', // Very light amber background
      '#ffeaa7', // Light amber
      '#fdcb6e', // Soft amber
      '#f39c12', // Medium amber
      '#e67e22', // Bright amber
      '#ffc107', // Primary loading state - amber
      '#e0a800', // Darker amber for borders
      '#d39e00', // Deep amber
      '#b8860b', // Very dark amber
      '#996515'  // Darkest amber
    ]
  },

  /** Typography optimized for technical interfaces */
  fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  fontFamilyMonospace: 'ui-monospace, SFMono-Regular, "SF Mono", Monaco, Consolas, "Liberation Mono", "Courier New", monospace',

  /** Spacing and sizing for dense technical layouts */
  spacing: {
    xs: '0.25rem',  // 4px
    sm: '0.5rem',   // 8px
    md: '1rem',     // 16px
    lg: '1.5rem',   // 24px
    xl: '2rem'      // 32px
  },

  /** Radius for consistent rounded corners */
  radius: {
    xs: '2px',
    sm: '4px',
    md: '6px',
    lg: '8px',
    xl: '12px'
  },

  /** Shadows for depth and focus states */
  shadows: {
    xs: '0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1)',
    sm: '0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.15)',
    md: '0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.15)',
    lg: '0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.15)',
    xl: '0 20px 25px rgba(0, 0, 0, 0.1), 0 10px 10px rgba(0, 0, 0, 0.15)'
  },

  /** Component-specific overrides for broadcast environment */
  components: {
    Button: {
      defaultProps: {
        size: 'sm',
        variant: 'filled'
      },
      styles: {
        root: {
          fontWeight: 500,
          transition: 'all 0.2s ease'
        }
      }
    },
    
    Grid: {
      defaultProps: {
        gutter: 'xs'
      }
    },

    Box: {
      styles: {
        root: {
          // Ensure smooth transitions for interactive elements
          transition: 'all 0.2s ease'
        }
      }
    },

    Text: {
      styles: {
        root: {
          // Ensure good readability for technical text
          lineHeight: 1.4
        }
      }
    },

    Tooltip: {
      defaultProps: {
        withArrow: true,
        position: 'top'
      },
      styles: {
        tooltip: {
          fontSize: '12px',
          fontWeight: 500,
          backgroundColor: 'var(--mantine-color-dark-7)',
          color: 'var(--mantine-color-gray-0)'
        }
      }
    },

    Loader: {
      defaultProps: {
        size: 'xs'
      },
      styles: {
        root: {
          // Ensure loaders are visible in all states
          zIndex: 10
        }
      }
    }
  },


})